import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import HeadFilterCard from './components/HeadFilterCard';
import Stack from '@mui/material/Stack';
import IndividualMonthlyPerfomanceTable from './perfomanceTableSecion/IndividualMonthlyPerfomanceTable';
import CourseSaleMatrixMain from '../courseSaleMatrix/CourseSaleMatrixMain';
import IndividualCardLanding from './components/IndividualCardLanding';
import IndividualChartLanding from './components/IndividualChartLanding';
/* import MonthlyWiseGlobalFilter from '../TeamWiseAnalytics/MonthlyWiseGlobalFilter';
import dayjs from 'dayjs' */
const InduvidualAnalyticsLanding = () => {
  /*  const [fromDate, setFromDate] = useState(dayjs().startOf('month'));
  const [toDate, setToDate] = useState(dayjs().endOf('month'));
  const [wing, setWing] = useState({ id: -1, value: '' });
 */
  return (
    <GlobalWrapper title={'Individual Analysis'}>
      {/*       <MonthlyWiseGlobalFilter
        fromDate={fromDate}
        toDate={toDate}
        setFromDate={setFromDate}
        setToDate={setToDate}
        selectedTeam={wing}
        setSelectedTeam={setWing}
      /> */}
      <Stack gap={2}>
        <HeadFilterCard />
        <IndividualCardLanding />
        <IndividualMonthlyPerfomanceTable />
        <IndividualChartLanding />
        <CourseSaleMatrixMain />
      </Stack>
    </GlobalWrapper>
  );
};

export default InduvidualAnalyticsLanding;
